import { CompanyEntity } from "../Company/CompanyEntity"
import { AddtionalMemory } from "./AddtionalMemory"
import { AwardMemory } from "./AwardMemory"
import { CategoryMemory } from "./CategoryMemory"
import { CustomerMemory as CostumerMemory } from "./CustomerMemory"
import { CatalogItemsMemory } from "./CatalogItemsMemory"
import { EmployeeMemory } from "./EmployeeMemory"
import { ExtraServiceMemory } from "./ExtraServiceMemory"
import { ProductsMemory } from "./ProductsMemory"
import { MemoryServicePoints } from "./ServicePointsMemory"
import { OrderMemory } from "./OrderMemory"
import { PromotionsMemory } from "./PromotionsMemory"
import { DeliveryMemory } from "./DeliveryMemory"
import { CourierMemory } from "./CourierMemory"
import { CouponMemory } from "./CouponMemory"
import { TutorialMemory } from "./TutorialMemory"
import { ComboMemory } from "./ComboMemory"
import { SelectionMemory } from "./SelectionMemory"
import { NoticeMemory } from "./NoticeMemory"
import { ManualExternalOrderMemory } from "./ManualExternalOrderMemory"
import { AdminEmployeeMemory } from "./AdminEmployeeMemory"

export const employeeMemory = new EmployeeMemory()

export const adminEmployeeMemory = new AdminEmployeeMemory()

export const extraServiceMemory = new ExtraServiceMemory()

export const promotionsMemory = new PromotionsMemory()

export const awardMemory = new AwardMemory()

export const productsMemory = new ProductsMemory()

export const categoryMemory = new CategoryMemory()

export const addtionalMemory = new AddtionalMemory()

export const catalogItemsMemory = new CatalogItemsMemory()

export const servicePointMemory = new MemoryServicePoints()

export const orderMemory = new OrderMemory()

export const companyMemory = new CompanyEntity({})

export const customerMemory = new CostumerMemory()

export const deliveryMemory = new DeliveryMemory()

export const courierMemory = new CourierMemory()

export const couponMemory = new CouponMemory()

export const tutorialMemory = new TutorialMemory()

export const comboMemory = new ComboMemory()

export const selectionMemory = new SelectionMemory()

export const noticeMemory = new NoticeMemory()

export const manualExternalOrderMemory = new ManualExternalOrderMemory()
